module.exports = __webpack_public_path__ + "img/bx-copy-alt.91dc381f.svg";